import React, { createContext, useEffect, useState } from "react";
import PropTypes from "prop-types";
import ApiClient from "../api/ApiClient";

export const AuthContext = createContext();

export default function AuthContextProvider({
  baseURL,
  storage,
  routeOnLogout,
  children,
}) {
  const apiClient = new ApiClient(baseURL, storage, routeOnLogout);

  const [session, setSession] = useState({
    token: null,
    creds: null,
    user: null,
    loaded: null,
  });

  const update = async () => {
    setSession({
      token: await apiClient.getTokenFromStorage(),
      creds: await apiClient.getCredsFromStorage(),
      user: await apiClient.getUserFromStorage(),
      loaded: true,
    });
  };

  useEffect(() => {
    update();
  }, []);

  return (
    <AuthContext.Provider
      value={{
        login: (username, password) =>
          apiClient.login(username, password).then(update),
        logout: () => apiClient.logout().then(update),
        token: session.token,
        creds: session.creds,
        user: session.user,
        isAuthenticated: session.loaded ? !!session.token : null,
        apiClient,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
}

AuthContextProvider.propTypes = {
  baseURL: PropTypes.string,
  storage: PropTypes.func,
  routeOnLogout: PropTypes.func,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]),
};
